import { Observable, switchMap, of } from 'rxjs';
import { AbFeatureFlag } from 'app/abstract/services/feature-flag.abstract';
import { AuthService } from 'app/shared/auth/auth.service';

export function inicializarFeatureFlags(servico: AbFeatureFlag, authService: AuthService): () => Observable<void> {
  return () => servico.carregarCapabilities().pipe(
    switchMap(() => {
      if (authService.isAuthenticated()) {
        return servico.carregarCapabilitiesPrivadas();
      }
      return of(void 0);
    })
  );
}
